
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/newsletter",
      function () {
        return require("private-next-pages/es/newsletter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/newsletter"])
      });
    }
  